import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: {},
};

const restaurantMetadata = createSlice({
    name: "restaurantMetadata",
    initialState,
    reducers: {
        setRestaurantMetadata(state, action) {
            state.data = action.payload;
        },
        clearRestaurantMetadata(state) {
            state.data = {};
        }
    },
});

export const { setRestaurantMetadata, clearRestaurantMetadata } = restaurantMetadata.actions;
export default restaurantMetadata.reducer;
